export const API = {
  endpoint: window.location.hostname === "localhost" ? "https://259s7s89-5004.inc1.devtunnels.ms/api/v1/" : "https://api.unzer.rejoicehub.com/api/v1/",
};
